// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RankingInsightIntro_wrap__1Ga46","txt_wrap":"RankingInsightIntro_txt_wrap__7-0eq","img_wrap":"RankingInsightIntro_img_wrap__1sbcd","box":"RankingInsightIntro_box__3BqQD"};